// extracted by mini-css-extract-plugin
export default {"title":"title-NY_r","failed":"failed-enVD"};